// shareCertificateEndpoint — resolves the public Sika Verified Return
// Certificate card URL. The card is a SERVER-SIDE rendered SVG
// (Ecosystem Edge §09) at the sika-certificate-share-card edge
// function, REPRODUCIBLE FROM the opaque share_token ALONE. The token
// (minted by get_or_create_sika_certificate_share) decouples the
// public URL from goal_id/user_id — no private data is exposed.

/** Canonical public server-rendered certificate-card image URL. */
export function shareCertificateCardUrl(token: string): string {
  const base = import.meta.env.VITE_SUPABASE_URL;
  const q = new URLSearchParams({ token });
  return `${base}/functions/v1/sika-certificate-share-card?${q.toString()}`;
}

/** Open the certificate card in a new tab. No-op when token is empty. */
export function openShareCertificate(token: string): void {
  if (!token) return;
  window.open(shareCertificateCardUrl(token), "_blank", "noopener");
}
